<template>
  <section class="w-screen h-screen absolute flex justify-center items-center z-[45]">
    <div id="modal modal-customer"
      class="modal absolute block bg-white dark:bg-dark-800 w-5/6 sm:w-9/12 shadow-md rounded-lg dark:shadow-dark-600"
      :class="{
        'animate__animated animate__zoomIn': showModal,
        'animate__animated animate__zoomOut': !showModal,
      }">
      <div id="modal-header" class="w-full bg-color-1 py-3 rounded-t-lg">
        <h5 class="text-white text-center font-bold text-xl">{{ isEdit ? 'Edit Item' : 'Tambah Item' }}</h5>
      </div>
      <div id="modal-body" class="p-5 max-h-[calc(100dvh-220px)] overflow-y-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <InputTextCustom v-model="itemName" id="item-name" label="Nama Item" placeholder="Masukkan nama item"
          :valid="validation.name.valid" :error-message="validation.name.message" />
        <InputSelect v-model="selectedCategoryId" id="category-select" label="Category" :options="optionItemCategories"
          placeholder="Pilih kategori" :valid="validation.item_category_id.valid"
          :error-message="validation.item_category_id.message" :isScrolled="true"/>
        <InputSelect v-model="itemUnitId" id="satuan-unit" label="Satuan" :options="optionUnits"
          placeholder="Pilih satuan" :valid="validation.unit_id.valid" :error-message="validation.unit_id.message" :isScrolled="true"/>
        <InputRupiah v-model="itemPrice" id="item-price" label="Harga" input_class="w-full"
          :valid="validation.sale_price.valid" :error-message="validation.sale_price.message" />
        <InputRupiah v-model="itemDiscountPrice" id="item-discount-price" label="Diskon" input_class="w-full"
          :valid="validation.discount_price.valid" :error-message="validation.discount_price.message" />
        <div class="flex items-center space-x-2">
          <input 
            type="checkbox" 
            id="monitorStock"
            v-model="itemMonitorStock" 
            class="h-4 w-4 rounded border-gray-300 text-gold-500 focus:ring-gold-500"
          />
          <label for="monitorStock" class="text-sm font-medium text-gray-700 dark:text-gray-300">
            Monitor Stok
          </label>
        </div>
        <InputRadio v-model="serviceChargeApplied" id="service-charge-applied" name="service-charge-applied"
          label="Service Charge" :options="[{ value: true, label: 'Ya' }, { value: false, label: 'Tidak' }]"
          :valid="validation.service_charge_applied.valid" :error-message="validation.service_charge_applied.message" />
        <InputRadio v-model="taxApplied" id="tax-applied" name="tax-applied" label="Pajak"
          :options="[{ value: true, label: 'Ya' }, { value: false, label: 'Tidak' }]" :valid="validation.tax_applied.valid"
          :error-message="validation.tax_applied.message" />
        <InputRadio v-model="discountApplied" id="discount-applied" name="discount-applied" label="Diskon"
          :options="[{ value: true, label: 'Ya' }, { value: false, label: 'Tidak' }]"
          :valid="validation.discount_applied.valid" :error-message="validation.discount_applied.message" />
        <!-- <InputRupiah v-model="itemPurchasePrice" id="item-purchase-price" label="Harga" input_class="w-full"
          :valid="validation.purchase_price.valid" :error-message="validation.purchase_price.message" /> -->
      </div>
      <div class="modal-footer p-5">
        <div class="flex justify-center">
          <SubmitButton id="close" button_name="Close"
            button_class="mx-1 text-red-600 border-red-600 hover:text-white hover:bg-red-600" @click="closeModal" />
          <SubmitButton id="submit" button_name="Submit" button_class="mx-1 bg-color-1 hover:bg-color-2 text-color-4"
            @click="submitItem" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import SubmitButton from '../form/SubmitButton.vue';
import InputRupiah from '../form/InputRupiah.vue';
import { mapActions, mapGetters } from 'vuex';
import InputTextCustom from '../form/InputTextCustom.vue';
import InputSelect from '../form/InputSelect.vue';
import InputRadio from '../form/InputRadio.vue';

export default {
  name: "ModalItem",
  props: {
    item: {
      type: Object,
      default: null,
    }
  },
  components: {
    SubmitButton, InputRupiah, InputTextCustom, InputSelect, InputRadio
  },
  data() {
    return {
      showModal: true,
      itemName: this.item ? this.item.name : '',
      selectedCategoryId: this.item ? this.item.item_category_id : '',
      // selectedMenuType: this.item ? this.item.menu_type : '',
      itemUnitId: this.item ? this.item.unit_id : '',
      itemPrice: this.item ? this.item.sale_price : 0,
      serviceChargeApplied: this.item ? this.item.service_charge_applied : null,
      taxApplied: this.item ? this.item.tax_applied : null,
      discountApplied: this.item ? this.item.discount_applied : null,
      itemDiscountPrice: this.item ? this.item.discount_price : 0,
      itemPurchasePrice: this.item ? this.item.purchase_price : 0,
      itemMonitorStock: this.item ? this.item.monitor_stock : false,
      // itemPurchasePrice: this.item ? this.item.purchase_price : 0,
      optionItemCategories: [],
      optionUnits: [],
      isEdit: !!this.item,
      menuTypes: [
        { id: 'food', name: 'Makanan' },
        { id: 'drink', name: 'Minuman' }
      ],
      validation: {
        unit_id: {
          valid: true,
          message: ''
        },
        name: {
          valid: true,
          message: ''
        },
        description: {
          valid: true,
          message: ''
        },
        sale_price: {
          valid: true,
          message: ''
        },
        discount_price: {
          valid: true,
          message: ''
        },
        // purchase_price: {
        //   valid: true,
        //   message: '',
        // },
        item_category_id: {
          valid: true,
          message: '',
        },
        service_charge_applied: {
          valid: true,
          message: '',
        },
        tax_applied: {
          valid: true,
          message: '',
        },
        discount_applied: {
          valid: true,
          message: '',
        }
      },
      field: ['unit_id', 'name', 'description', 'sale_price', 'item_category_id','discount_applied','service_charge_applied','tax_applied','discount_price'],
    }
  },
  computed: {
    ...mapGetters('item_categories', ['allItemCategories']),
    ...mapGetters('units', ['allUnits'])
  },
  async created() {
    await Promise.all([
      this.$store.dispatch('item_categories/fetchItemCategories', { limit: 1000, status: 'active' }),
      this.$store.dispatch('units/fetchUnits', { limit: 1000 }),
    ]);
    this.optionItemCategories = this.allItemCategories.map(category => ({ label: category.name, value: category.id }));
    this.optionUnits = this.allUnits.map(unit => ({ label: unit.name, value: unit.id }));
  },
  watch: {
    item(newVal) {
      if (newVal) {
        this.itemName = newVal.name;
        this.selectedCategoryId = newVal.category_id;
        this.selectedMenuType = newVal.menu_type;
        this.itemUnitId = newVal.unit_id;
        this.itemPrice = newVal.sale_price || 0;
        this.serviceChargeApplied = newVal.service_charge_applied || false;
        this.taxApplied = newVal.tax_applied || false;
        this.discountApplied = newVal.discount_applied || false;
        this.itemDiscountPrice = newVal.discount_price || 0;
        this.itemPurchasePrice = newVal.purchase_price || 0;
        this.itemMonitorStock = newVal.monitor_stock || false;
        // this.itemPurchasePrice = newVal.purchase_price || 0;
        this.isEdit = true;
      } else {
        this.itemName = '';
        this.selectedCategoryId = '';
        this.selectedMenuType = '';
        this.itemUnitId = '';
        this.itemPrice = 0;
        this.serviceChargeApplied = false;
        this.taxApplied = false;
        this.discountApplied = false;
        this.itemDiscountPrice = 0;
        this.itemPurchasePrice = 0;
        this.itemMonitorStock = false;
        // this.itemPurchasePrice = 0;
        this.isEdit = false;
      }
    }
  },
  methods: {
    ...mapActions('items', ['createItem', 'updateItem']),
    closeModal() {
      this.showModal = false;
      setTimeout(() => {
        this.$emit('closeModal');
      }, 200);
    },
    submitItem() {
      this.$confirm.require({
        group: 'headless',
        header: 'Apakah anda yakin ingin menyimpan item?',
        message: 'Silahkan konfirmasi sebelum diproses.',
        acceptLabel: 'Ya',
        rejectLabel: 'Tidak',
        accept: () => {
          this.postItem();
        },
        reject: () => {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'Kamu telah membatalkan aksi simpan item', life: 3000 });
        }
      });
    },
    async postItem() {
      try {
        const itemData = {
          name: this.itemName,
          item_category_id: this.selectedCategoryId,
          menu_type: 'food',
          unit_id: this.itemUnitId,
          sale_price: parseInt(this.itemPrice) || 0,
          service_charge_applied: this.serviceChargeApplied,
          tax_applied: this.taxApplied,
          discount_applied: this.discountApplied,
          discount_price: parseInt(this.itemDiscountPrice) || 0,
          purchase_price: 0,
          monitor_stock: this.itemMonitorStock,
        };

        if (this.isEdit && this.item) {
          itemData.id = this.item.id;
          await this.updateItem(itemData);
        }
        else {
          itemData.is_active = false;
          await this.createItem(itemData);
        }

        this.closeModal();
        this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Item berhasil disimpan', life: 5000 });
      }
      catch (error) {
        console.error('Failed to save item:', error);

        if (error.status === 400 && error.response.data.errors) {
          this.validationErrors(error.response.data.errors);
          this.$toast.add({ severity: 'error', summary: 'Failed', detail: error.response.data.message, life: 5000 });
        }
        else {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: error.response.data.message, life: 5000 });
        }
      }
    },
    validationErrors(errorMessage) {
      for (let index = 0; index < this.field.length; index++) {
        this.validation[this.field[index]].valid = true;
        this.validation[this.field[index]].message = '';
      }

      errorMessage.forEach((error) => {
        if (this.validation[error.field]) {
          this.validation[error.field].valid = false;
          this.validation[error.field].message = error.message;
        }
      });
    }
  }
}
</script>